import type { AdminAllStore, AdminAllStoresResponse } from '../types/features/adminAllStores';

export type ProcessedStoreRow = {
  id: string;
  name: string;
  ownerName: string;
  ownerPhone: string;
  subscription_status: string | null;
  registrationDate: string; // ISO
  remainingDays: number | '-';
  posSync: 'Yes' | 'No';
  raw: AdminAllStore;
};

export function transformStoresSummary(data?: AdminAllStoresResponse | null): ProcessedStoreRow[] {
  const stores = data?.stores || [];
  return stores.map((store) => {
    const registrationDate = store.created_at || store.store_created_at || '';
    const remainingDays = typeof store.remaining_days === 'number'
      ? store.remaining_days
      : '-';
    const posSync: 'Yes' | 'No' = store.pos_type && store?.pos_type !== 'n/a' ? 'Yes' : 'No';

    return {
      id: store.id,
      name: store.name,
      ownerName: store.owner_name || '',
      ownerPhone: store.owner_phone || '',
      subscription_status: store.subscription_status || null,
      registrationDate,
      remainingDays,
      posSync,
      raw: store,
    };
  });
}
